import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-hashtag text-sm"></i>
            热门标签
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            话题广场
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            当下最热门的讨论话题，点击进入话题专区查看更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 hover:-translate-y-0.5 ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200'
              }`}
            >
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
              <span className={`text-xs flex-shrink-0 ${
                item.hot ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.posts}帖
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}